import React from 'react'

import './HobbiesPage.css'

import { Fade} from 'react-animated-components'

import img1 from '../../images/drawing-img/11.jpg'
import img2 from '../../images/drawing-img/13.jpeg'
import img3 from '../../images/drawing-img/14.jpeg'
import img4 from '../../images/drawing-img/4.jpg'
import img5 from '../../images/drawing-img/15.jpeg'
import img6 from '../../images/drawing-img/16.jpeg'

export default function HobbiesPage() {
  return (
    <Fade
      ref={{
        current: '[Circular]'
      }}
      onActive={function noRefCheck(){}}
      onComplete={function noRefCheck(){}}
    >
      <div className='HobbiesPage'>
        <div className='HobbiesPageLeft'>
          <h2 className='HobbiesTitle'>
            My <span>Hobbies</span>
          </h2>
          <div className='HobbiesParagraphs'>
            <p>
              I feel that hobbies are a great thing God has designated for creative people. I thank God for giving me many talents and hobbies. My hobby is drawing, as I feel that it expresses my soul and makes it hang high in the sky. And how much I love <b>drawing space and galaxies</b>, I feel it represents my personality. I love reading and writing too.
            </p>
            <p>
            If you have any weird and creative ideas, feel free to message me so we can make beautiful miracles.
            </p>
          </div>
        </div>
        <div className="HobbiesPageRight">
          <center>
            <div>
              <div
                style={{
                  width: 300,
                  height: 300
                }}
              >
                <div className="stage-cube-cont">
                  <div className="cubespinner">
                    <div className="face1">
                      <img src={img1} alt="img"></img>
                    </div>
                    <div className="face2">
                      <img src={img2} alt="img"></img>
                    </div>
                    <div className="face3">
                      <img src={img3} alt="img"></img>
                    </div>
                    <div className="face4">
                      <img src={img4} alt="img"></img>
                    </div>
                    <div className="face5">
                      <img src={img5} alt="img"></img>
                    </div>
                    <div className="face6">
                      <img src={img6} alt="img"></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </center>
        </div>
      </div>
    </Fade>
  )
}
